import {
  faBug,
  faEllipsisH,
  faPrint,
  faShare,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import styled from "styled-components";
import useToggle from "../../hooks/use-toggle";

const { version } = require("../../../package.json");

interface Props {
  sheetName: string;
  onChangeSheet?(): void;
  onToggleShareDialog?(): void;
}

const AppMenu: React.FC<Props> = (props) => {
  const { onToggleShareDialog, sheetName, onChangeSheet } = props;

  const [showEllipsisMenu, toggleEllipsisMenu] = useToggle(false);

  return (
    <Root>
      <Button color="link" onClick={onChangeSheet}>
        {sheetName}
      </Button>

      <Dropdown isOpen={showEllipsisMenu} toggle={toggleEllipsisMenu}>
        <DropdownToggle size="sm" outline>
          <FontAwesomeIcon icon={faEllipsisH} />
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={onToggleShareDialog}>
            <FontAwesomeIcon icon={faShare} /> Teilen
          </DropdownItem>
          <DropdownItem onClick={() => window.print()}>
            <FontAwesomeIcon icon={faPrint} /> Drucken
          </DropdownItem>
          {process.env.NODE_ENV === "development" && (
            <DropdownItem href="#debug">
              {" "}
              <FontAwesomeIcon icon={faBug} /> Debug
            </DropdownItem>
          )}{" "}
          <DropdownItem divider />
          <DropdownItem header>v{version}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

AppMenu.defaultProps = {
  onChangeSheet: () => {},
  onToggleShareDialog: () => {},
};

export default AppMenu;
